/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import { SnackbarProvider } from 'notistack';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';

import styles from './styles';
import AuthWrapper from './components/AuthWrapper';
import Header from './components/Header';
import Notifier from './components/Notifier';
import LoginPage from './components/LoginPage';
import AuthoriseBuilderPage from './components/AuthoriseBuilderPage';
import JobsContainer from './components/JobsContainer';
import RegistrationContainer from './components/RegistrationContainer';
import MyBuildProfileContainer from './components/MyBuildProfileContainer';
import SettingsContainer from './components/SettingsContainer';
import LicenseExpiryModalContainer from './components/LicenseExpiryModal';
import FAQPageContainer from './components/FAQPageContainer';
import LeftSidebarPageContainer from './components/LeftSidebarPageContainer';

const propTypes = {
  classes: PropTypes.shape({
    notificationRoot: PropTypes.string,
  }).isRequired,
};

const App = ({ classes }) => (
  /* eslint-disable prettier/prettier, react/jsx-first-prop-new-line */
  <>
    {(process.env.REACT_APP_API === 'development'
      || process.env.REACT_APP_API === 'staging'
      || process.env.REACT_APP_API === 'production') && (
        <Helmet>
          <script type='text/javascript' src={`/nr-bundle-${process.env.REACT_APP_API}.js`}>
          </script>
        </Helmet>
      )}
    <SnackbarProvider
      hideIconVariant
      classes={{
        variantSuccess: classes.notificationSuccess,
        variantError: classes.notificationError,
        variantWarning: classes.notificationWarning,
        variantInfo: classes.notificationInfo,
      }}
    >
      <div id="app-wrapper">
        <Header />
        <AuthWrapper>
          <LeftSidebarPageContainer />
        </AuthWrapper>
        <Switch>
          <Route exact path="/" render={() => <AuthWrapper unAuthenticatedURL="/log-in" noNotification><Redirect to='/my-jobs' /></AuthWrapper>} />
          <Route exact path="/log-in" component={LoginPage} />
          <Route exact path="/authorise" component={AuthoriseBuilderPage} />
          <Route exact path="/deactivate" render={(props)=><AuthoriseBuilderPage {...props} isDeactivate/> }/>
          <Route exact path="/registration" component={RegistrationContainer} />
          <Route exact path="/faq" component={FAQPageContainer} />
          <Route path="/my-jobs" render={() => (<AuthWrapper><JobsContainer /></AuthWrapper>)} />
          <Route path="/my-build-profile" render={() => (<AuthWrapper><MyBuildProfileContainer /></AuthWrapper>)} />
          <Route path="/settings" render={() => (<AuthWrapper><SettingsContainer /></AuthWrapper>)} />
          <Route path="/" render={() => <AuthWrapper unAuthenticatedURL="/log-in"><Redirect to='/my-jobs' /></AuthWrapper>} />
        </Switch>
      </div>
      <Notifier />
      <AuthWrapper noNotification><LicenseExpiryModalContainer /></AuthWrapper>
    </SnackbarProvider>
  </>
);

App.propTypes = propTypes;

export default withStyles(styles)(App);
